import { render, staticRenderFns } from "./AddBuildingModal.vue?vue&type=template&id=85026784&"
import script from "./AddBuildingModal.vue?vue&type=script&lang=js&"
export * from "./AddBuildingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85026784')) {
      api.createRecord('85026784', component.options)
    } else {
      api.reload('85026784', component.options)
    }
    module.hot.accept("./AddBuildingModal.vue?vue&type=template&id=85026784&", function () {
      api.rerender('85026784', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/settings/engineers/AddBuildingModal.vue"
export default component.exports